import React, { useEffect, useMemo, useRef, useState } from 'react'
import FilterListIcon from '@mui/icons-material/FilterList'
import {
  Box,
  Button,
  Menu,
  Paper,
  SxProps,
  Theme,
  Typography
} from '@mui/material'
import { StyledIconButton } from 'common/Button/Button'

import CustomFilterSection from './CustomFilterSection'

export const getWinbackFilterOptions = (
  original: string[],
  filtered?: string[]
) => {
  if (filtered && filtered.length > 0) {
    return Array.from(new Set(filtered)).map((option) => {
      if (option === '') {
        return '(Blank)'
      }
      return option
    })
  }
  return Array.from(new Set(original)).map((option) => {
    if (option === '') {
      return '(Blank)'
    }
    return option
  })
}

export default function CustomWinbackDataGridFilter(props: FilterProps) {
  const { filterFields, setFilterActive, rows, setFilteredRows, menuSx } = props
  const [activeCheckBoxes, setActiveCheckBoxes] = useState<number>(0)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const divRef = useRef<HTMLDivElement>(null)
  const open = Boolean(anchorEl)
  const handleFilterClick = () => {
    setAnchorEl(divRef.current)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  // let filterActive = false
  const checkedFilterFields = filterFields.filter((field) => {
    return field.checked.length > 0
  })
  useEffect(() => {
    if (checkedFilterFields.length > 0) {
      setFilterActive(true)
    } else {
      setFilterActive(false)
    }
  }, [checkedFilterFields])
  const tempFilteredRows = useMemo(() => {
    let searchFilteredRows

    if (rows) {
      searchFilteredRows = []
      filterFields.forEach((field) => {
        if (field.checked.length > 0) {
          const tempRows =
            searchFilteredRows.length > 0 ? searchFilteredRows : rows
          searchFilteredRows = tempRows.filter((data) => {
            return data.updateStatus.includes(field.checked)
          })
        }
      })
    }
    return searchFilteredRows
  }, [...filterFields.map((field) => field.checked), rows])
  useEffect(() => {
    setFilteredRows(tempFilteredRows)
  }, [tempFilteredRows])

  useEffect(
    () => {
      const count = () => {
        let checkboxCount = 0
        filterFields.forEach((field) => {
          checkboxCount += field.checked.length
        })
        return checkboxCount
      }
      setActiveCheckBoxes(count())
    },
    filterFields.map((field) => field.checked)
  )

  const resetFilter = () => {
    setFilterActive(false)
    filterFields.forEach((field) => {
      field.setChecked([])
    })
    setFilteredRows([])
  }

  return (
    <>
      <StyledIconButton onClick={handleFilterClick}>
        <div ref={divRef}>
          <FilterListIcon />
        </div>
        <Typography sx={{ color: 'primary.main' }}>
          {' '}
          Filter {activeCheckBoxes > 0 ? `(${activeCheckBoxes})` : ''}
        </Typography>
      </StyledIconButton>

      <Paper sx={{ width: '100%' }}>
        <Menu
          id='basic-menu'
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          sx={{ position: 'absolute', ...menuSx }}
        >
          <Box sx={{ margin: '0 16px' }}>
            {filterFields.map((filterField, index) => (
              <CustomFilterSection key={index} filterField={filterField} />
            ))}
          </Box>
          <Button
            variant='outlined'
            onClick={resetFilter}
            sx={{
              fontWeight: 400,
              ml: '20px',
              mt: '-10px',
              color: '#333333',
              borderColor: '#333333',
              borderWidth: '1px',
              height: '30px',
              px: '12px',
              py: '6px'
            }}
          >
            Reset
          </Button>
        </Menu>
      </Paper>
    </>
  )
}

export interface FilterProps {
  filterFields: IFilterField[]
  filterActive: boolean
  setFilterActive: React.Dispatch<React.SetStateAction<boolean>>
  rows
  setFilteredRows
  menuSx?: SxProps<Theme> | undefined
}

export interface IFilterField {
  name: string
  index: string
  values: string[]
  checked: string[]
  setChecked: React.Dispatch<React.SetStateAction<string[]>>
}
